import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

const FeatureData = [
  {
    title: "Quick Learning",
    desc: "Get instant math solutions and concise notes so concepts stick faster between classes.",
    icon: "ri-flashlight-line",
    to: "/divein",
  },
  {
    title: "Always Ready",
    desc: "Open the toolkit whenever you need a second pass — homework nights included.",
    icon: "ri-time-line",
    to: "/divein",
  },
  {
    title: "Study Momentum",
    desc: "Keep progress visible with tools that turn messy inputs into usable study material.",
    icon: "ri-rocket-2-line",
    to: "/subscription",
  },
];

const Features = () => {
  return (
    <section className="bg-white py-20">
      <Container>
        <div className="mb-10 max-w-[540px]">
          <p className="section-label">Benefits</p>
          <h2 className="m-0">Built for how students actually study</h2>
        </div>
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {FeatureData.map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className="group flex min-h-full flex-col items-start rounded-[20px] border border-transparent bg-brand-surface px-6 py-7 no-underline transition hover:-translate-y-1 hover:border-brand-teal/35 hover:bg-white hover:shadow-brand"
            >
              <span className="mb-5 inline-flex h-[52px] w-[52px] items-center justify-center rounded-[14px] border border-brand-teal/25 bg-white">
                <i className={`${item.icon} text-[1.45rem] text-brand-teal-dark`} />
              </span>
              <h3 className="mb-2.5 text-xl">{item.title}</h3>
              <p className="mb-5 flex-1 text-base leading-relaxed">{item.desc}</p>
              <span className="inline-flex items-center gap-1 font-display text-[0.92rem] font-semibold text-brand-teal-dark">
                Explore{" "}
                <i className="ri-arrow-right-line text-brand-teal-dark transition group-hover:translate-x-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Features;
